import { el } from 'redom';

import InputBox from 'generics/components/input-box';
import DateInput from '../date-input';
import TimeInput from '../time-input';

import './index.scss';

class DateTimeInputBox {

  constructor(configuration) {

    this.onChange = configuration.onChange;

    this.dateInputBox = new InputBox({
      input: new DateInput({
        disabled: configuration.disabled,
        value: configuration.value.date,
        placeholder: configuration.placeholder.date,
        onChange: this.handleDateChange.bind(this)
      })
    });
    this.timeInputBox = new InputBox({
      input: new TimeInput({
        disabled: configuration.disabled,
        value: configuration.value.time,
        placeholder: configuration.placeholder.time,
        onChange: this.handleTimeChange.bind(this)
      })
    });

    this.el = el('.date-time-input-box-main', [
      this.dateInputBox,
      this.timeInputBox
    ]);

  }

  handleDateChange(event, value) {

    this.onChange({
      date: value,
      time: this.timeInputBox.getValue(),
      dateTime: this.dateInputBox.input.getValueAsNumber() + this.timeInputBox.input.getValueAsNumber()
    });

  }

  handleTimeChange(event, value) {

    this.onChange({
      date: this.dateInputBox.getValue(),
      time: value,
      dateTime: this.dateInputBox.input.getValueAsNumber() + this.timeInputBox.input.getValueAsNumber()
    });

  }

  setValue(value) {

    if (value.date !== void 0) {
      this.dateInputBox.setValue(value.date);
    }
    if (value.time !== void 0) {
      this.timeInputBox.setValue(value.time);
    }

  }

  setError(errorMessage) {

    if (errorMessage.date !== void 0) {
      this.dateInputBox.setError(errorMessage.date);
    }
    if (errorMessage.time !== void 0) {
      this.timeInputBox.setError(errorMessage.time);
    }

  }

  clearError() {

    this.dateInputBox.clearError();
    this.timeInputBox.clearError();

  }

  getDateTime() {

    const dateString = this.dateInputBox.getValue();
    const timeString = this.timeInputBox.getValue();

    const dateParts = dateString.split('-');
    const timeParts = timeString.split(':');

    const day = parseInt(dateParts[2], 10);
    const month = parseInt(dateParts[1], 10) - 1; // Adjust for 0-indexed months
    const year = parseInt(dateParts[0], 10);
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);

    const combinedDate = new Date(year, month, day, hours, minutes);

    return combinedDate.getTime();

  }

  getValue() {

    const value = {
      date: this.dateInputBox.getValue(),
      time: this.timeInputBox.getValue(),
      dateTime: this.getDateTime()
    };

    return value;

  }

  focus() {

    this.dateInputBox.focus();

  }

}

export default DateTimeInputBox;